<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Citatblock
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Framhävt citat eller central insikt i en artikel. En teal vänsterkant
      markerar blocket.
    </p>

    <PreviewFull label="Exempel">
      <blockquote class="m-0 pl-5 py-1" style="border-left: 4px solid #14b8a6">
        <p
          class="font-[Plus_Jakarta_Sans] italic text-[17px] text-[#191c1e] leading-[1.7] m-0"
        >
          "Autolys handlar om tålamod. De 30 minuterna av vila gör mer för din
          deg än vilken knådningstech som helst."
        </p>
      </blockquote>
    </PreviewFull>

    <PreviewFull label="Med attribution">
      <blockquote class="m-0 pl-5 py-1" style="border-left: 4px solid #14b8a6">
        <p
          class="font-[Plus_Jakarta_Sans] italic text-[17px] text-[#191c1e] leading-[1.7] mb-2"
        >
          "Salt är inte bara smak — det stärker glutenstrukturen och reglerar
          jästens aktivitet."
        </p>
        <cite
          class="font-[Poppins] font-bold text-[12px] text-[#6c7a77] not-italic tracking-[0.5px]"
          >Emma Lagerqvist</cite
        >
      </blockquote>
    </PreviewFull>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import PreviewFull from "../components/PreviewFull.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<blockquote class="m-0 pl-5 py-1" style="border-left: 4px solid #14b8a6">
  <p class="font-[Plus_Jakarta_Sans] italic text-[17px] text-[#191c1e] leading-[1.7] m-0">
    "Ditt citat här."
  </p>
  <!-- Valfri attribution -->
  <cite class="font-[Poppins] font-bold text-[12px] text-[#6c7a77] not-italic tracking-[0.5px]">
    Författare
  </cite>
</blockquote>`;

const cssCode = `/* Vänsterkant */
border-left: 4px solid #14b8a6;

/* Padding vänster */
padding-left: 20px;   /* pl-5 */

/* Text */
font-family: 'Plus Jakarta Sans', sans-serif;
font-style: italic;
font-size: 17px;
line-height: 1.7;

/* Attribution */
font-family: 'Poppins', sans-serif;
font-weight: 700;
font-size: 12px;
font-style: normal;
text-transform: uppercase;
letter-spacing: 0.5px;`;

const snippetTabs = [
  { label: "HTML", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
</script>
